import { render, staticRenderFns } from "./topCov.vue?vue&type=template&id=3a094a09&scoped=true"
import script from "./topCov.vue?vue&type=script&lang=js"
export * from "./topCov.vue?vue&type=script&lang=js"
import style0 from "./topCov.vue?vue&type=style&index=0&id=3a094a09&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a094a09",
  null
  
)

export default component.exports